import { render, staticRenderFns } from "./SpectrumHarmWidgetComponent.vue?vue&type=template&id=2625727f&scoped=true&"
import script from "./SpectrumHarmWidgetComponent.vue?vue&type=script&lang=ts&"
export * from "./SpectrumHarmWidgetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SpectrumHarmWidgetComponent.vue?vue&type=style&index=0&id=2625727f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625727f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
